<template>
  <div class="main-container-shipmentinfo">
    <LoadingData v-if="loadingDeliveryRouteUpdate" :headerMessage="'Updating shipment routes'"/>

    <div class="inner-container" id="printable-content">
        <div class="confirm-container-main">
                <div class="close-shipment-info-container">
                    <svg class="close-shipment-info" @click="closeReassignRoutePopUp()" viewBox="0 0 512 512" xml:space="preserve" xmlns="http://www.w3.org/2000/svg">
                        <path d="M255.997 460.351c112.685 0 204.355-91.668 204.355-204.348S368.682 51.648 255.997 51.648c-112.68 0-204.348 91.676-204.348 204.355s91.668 204.348 204.348 204.348zm0-376.463c94.906 0 172.123 77.209 172.123 172.115 0 94.898-77.217 172.117-172.123 172.117-94.9 0-172.108-77.219-172.108-172.117-.001-94.906 77.207-172.115 172.108-172.115z" fill="#32ccfe" class="fill-000000"></path>
                        <path d="M172.077 341.508a18.35 18.35 0 0 0 12.903 5.27c4.776 0 9.54-1.84 13.151-5.512l57.865-58.973 57.878 58.973a18.372 18.372 0 0 0 13.146 5.512c4.658 0 9.316-1.746 12.902-5.27 7.264-7.125 7.369-18.793.242-26.051l-58.357-59.453 58.357-59.461c7.127-7.258 7.021-18.92-.242-26.047-7.252-7.123-18.914-7.018-26.049.24l-57.878 58.971-57.865-58.971c-7.135-7.264-18.797-7.363-26.055-.24-7.258 7.127-7.369 18.789-.236 26.047l58.351 59.461-58.351 59.453c-7.131 7.258-7.02 18.926.238 26.051z" fill="#32ccfe" class="fill-000000"></path>
                    </svg>
                </div>
                
                <div class="confirm-header-container">
                    <h1 class="package-details-header">Reassign Route Details</h1>
                    <img src="../../../assets/LREXDinoFooter.jpg" alt="">
                </div>

                <div class="inner-overflow-container" id="inner-overflow-container">
                        <div class="confirmContainerInner">
                            <div class="confirm-container-address">
                                <div class="confirmContainerInner1">
                                    <div class="confirm-svg">
                                        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 159.75 148.87">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M154.27,12.53c.87-.17,1.78,0,2.54,.46,1.29,.53,2.2,1.79,2.2,3.28l.74,103.46c.07,1.27-.56,2.54-1.73,3.22l-42.25,25.21c-.6,.46-1.34,.72-2.15,.72-.2,0-.39-.01-.57-.05L3.39,136.62c-1.89-.08-3.39-1.64-3.39-3.55V27.85H0c-.04-1.4,.75-2.77,2.13-3.37L57.14,.31h0c.57-.26,1.22-.36,1.9-.27l95.23,12.49h0Zm-37.27,30.93v96.48l36-21.47-.7-97.26-35.3,22.25h0Zm-7,97.91V45l-46.8-5.97-1.54,44.72-16.43-11.19-16.43,9.29,3.4-46.78-25.19-3.21v98.07l103,11.44h0ZM102.56,12.88l-34.52,19.59,44.9,5.72,31.47-19.83-41.86-5.49h0ZM36.56,28.46L70.02,8.61l-11.03-1.44L16.4,25.89l20.15,2.56h0Z"/>
                                            </g>
                                        </svg>
                                        <h2>Selected Shipments</h2>
                                    </div>

                                    <div class="confirmContainerInner1">
                                        <p>You have selected <span style="font-weight: bold;">{{selectedShipmentArray.length}}</span> shipment(s) to update.</p>
                                        <p>Select a route below, then click 'Update Route' to reassign these shipments.</p>
                                    </div>

                                    <div class="confirmContainerInner1">
                                        <h2>Shipment IDs</h2>

                                        <div class="scrollable-container">
                                            <div v-if="selectedShipmentArray.length">
                                                <div class="scrollable-container-inner" v-for="(id, index) in selectedShipmentArray" :key="index">
                                                    <p>{{ id }}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="selectedRoute != ''" class="confirmContainerInner1 animate-route-select">
                                    <div class="confirm-svg">
                                        <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24">
                                            <path d="M7,19c0,1.105-.895,2-2,2s-2-.895-2-2,.895-2,2-2,2,.895,2,2Zm12-2c-1.105,0-2,.895-2,2s.895,2,2,2,2-.895,2-2-.895-2-2-2Zm-10.465-5.458l-1.921,1.878c-.89,.871-2.338,.871-3.229,0l-1.913-1.871c-1.957-1.958-1.957-5.129-.008-7.079,1.862-1.939,5.21-1.94,7.07,0,1.949,1.95,1.949,5.122,0,7.071Zm-1.414-5.657c-1.116-1.163-3.126-1.164-4.242,0-1.17,1.169-1.17,3.073,0,4.243l1.905,1.863c.121,.119,.311,.118,.432,0l1.913-1.871c1.162-1.162,1.162-3.065-.008-4.235Zm-2.121,.616c-.828,0-1.5,.672-1.5,1.5s.672,1.5,1.5,1.5,1.5-.672,1.5-1.5-.672-1.5-1.5-1.5Zm17.535,5.042l-1.921,1.878c-.89,.871-2.338,.871-3.229,0l-1.913-1.871c-1.957-1.958-1.957-5.129-.008-7.079,1.862-1.939,5.21-1.94,7.07,0,1.949,1.95,1.949,5.122,0,7.071Zm-1.414-5.657c-1.116-1.163-3.126-1.164-4.242,0-1.17,1.169-1.17,3.073,0,4.243l1.905,1.863c.122,.119,.311,.118,.432,0l1.913-1.871c1.162-1.162,1.162-3.065-.008-4.235Zm-2.121,.616c-.828,0-1.5,.672-1.5,1.5s.672,1.5,1.5,1.5,1.5-.672,1.5-1.5-.672-1.5-1.5-1.5Zm-5,11.5h-4c-.553,0-1,.448-1,1s.447,1,1,1h4c.553,0,1-.448,1-1s-.447-1-1-1Z"/>
                                        </svg>
                                        <h2>Selected Route</h2>
                                    </div>

                                    <div v-if="selectedRoute != ''" class="confirmContainerInner1">
                                        <p>You have selected route <span style="font-weight: bold;">{{selectedRoute}}</span>.</p>
                                        <p>Click 'Update Route' to reassign these shipments.</p>
                                    </div>
                                </div>

                                <div class="route-table-container">
                                    <route-management-table @selectRouteCode="selectRouteCode($event)" :key="refreshKey" :jwtToken="jwtToken" :userData="userData"/>
                                </div>
                            </div>
                        </div>
                    </div>

                    <loading-charts v-if="loadingData"/>
                    <button v-if="selectedRoute != ''" class="create-button" @click="toggleRouteReassign()">Update Route</button>
            </div>
    </div>
  </div>
<div v-if="toggleRouteReassignWarning" class="alert-container">
    <div class="inner-container">
        <div class="text-container">
        <p>Are you sure?</p>
        <button @click="updateAllShipments()" class="create-button">Confirm</button>
        <button @click="toggleRouteReassign()" class="print-button">Cancel</button>
        </div>
    </div>
</div>
<AlertUser v-if="toggleAlertBox" @closeAlertBox="closeAlertBox($event)" :message="alertMessage"/>
</template>

<script>
import {API} from 'aws-amplify';
import AlertUser from '../../../components/Popups/AlertUser.vue';
import LoadingCharts from '../../ShipmentDashboard/LoadingCharts.vue';
import { updateShipmentActivity } from '../../../graphql/mutations';
import RouteManagementTable from '../RouteDashboard/RouteManagementTable.vue'
import LoadingData from '../../Popups/LoadingData.vue';

export default {
    props:['jwtToken', 'userData', 'selectedShipmentArray'],
    components:{
        AlertUser,
        LoadingCharts,
        RouteManagementTable,
        LoadingData
    },
    data(){
        return{
            routeCodeData: null,
            isActive: undefined,
            toggleAlertBox: false, 
            alertMessage: null,
            loadingData: false,
            toggleServiceData: "",
            serviceNetworkData: {},
            toggleRouteReassignWarning: false,
            selectedRoute: "",
            loadingDeliveryRouteUpdate: false
        }
    },
    methods:{
        async selectRouteCode(event){
            this.selectedRoute = "";
            this.selectedRoute = event.routeCode;
        },
        async toggleRouteReassign(){
            this.toggleRouteReassignWarning = !this.toggleRouteReassignWarning;
        },
        async updateShipmentDeliveryRoute(shipmentID, selectedRoute){
            let date = new Date();
            this.loadingData = true;
            this.toggleRouteReassignWarning = false;

            let shipmentJSON = {
                serviceAddress: {
                    address:{
                        routeCode: selectedRoute
                    }
                }
            }
            //Status ID 47 = Reassign Delivery Route 
            try {
                let shipmentActivity = await API.graphql({
                    query: updateShipmentActivity,
                    variables: {
                        input: {
                            shipmentID: shipmentID,
                            ShipmentId: parseInt(shipmentID),
                            statusID: "47",
                            Code: "47",
                            RecordedTime: date.toJSON(),
                            InternalComments: selectedRoute,
                            Latitude: "",
                            Longitude: "",
                            shipment: JSON.stringify(shipmentJSON)
                        }
                    },
                    authMode: "AMAZON_COGNITO_USER_POOLS",
                })
                this.toggleAlertBox = true;
                this.alertMessage = "Route updated"
                console.log(shipmentActivity.data.updateShipmentActivity)
                this.internalCommentInput = "";
            } catch (error) {
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to update shipment."
                this.loadingData = false;
            }
        },
        async updateAllShipments() {
            this.loadingDeliveryRouteUpdate = true;
            try {
                await Promise.all(
                    this.selectedShipmentArray.map(id => this.updateShipmentDeliveryRoute(id, this.selectedRoute))
                );
                console.log("All shipments updated successfully.");
                this.toggleAlertBox = true;
                this.alertMessage = "All shipments updated successfully."
            } catch (error) {
                console.error("Error updating one or more shipments:", error);
                this.toggleAlertBox = true;
                this.alertMessage = "Unable to update shipment."
                this.loadingData = false;
            }finally{
                this.loadingDeliveryRouteUpdate = false;
            }
        },
        closeAlertBox(toggleAlertBox){
            this.toggleAlertBox = toggleAlertBox;
            this.closeReassignRoutePopUp();
        },
        closeReassignRoutePopUp(){
            this.$emit('closeReassignRoutePopUp', false)
        }
    },
    mounted(){
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }
}
</script>

<style scoped>
select {
  padding: 10px;
  font-size: 15px;
  border: 1px solid rgba(0, 0, 0, 0.336);
  border-radius: 15px;
  outline: 0;
  margin-top: 5px;
  margin-left: auto;
}
.main-container-shipmentinfo {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  margin: 0;
  padding: 0;
  z-index: 10;
}
@keyframes shipment-details-animate {
  from {
    margin-top: -2%;
  }
  to {
    margin-top: 2.5%;
  }
}
.inner-container {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  flex-direction: column;
}
.confirm-container-main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: fit-content;
  max-height: 90vh;
  overflow-x: auto;
  animation: shipment-details-animate 1s ease;
  margin-top: 2.5%;
  box-shadow: rgba(0, 0, 0, 0.164) 0 1px 10px;
  background-color: #fff;
  border-radius: 25px;
  box-shadow: rgba(0, 0, 0, 0.25) 0 54px 55px, rgba(0, 0, 0, 0.12) 0 -12px 30px,
    rgba(0, 0, 0, 0.12) 0 4px 6px, rgba(0, 0, 0, 0.17) 0 12px 13px,
    rgba(0, 0, 0, 0.09) 0 -3px 5px;
}
.confirm-header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 15px 0 15px;
  justify-content: space-between;
}
.confirm-header-container img {
  width: 40px;
  margin-right: 15px;
}
.weight-container {
  background-color: #fff;
  margin: 0 5% 2% 5%;
  padding: 10px;
  border-radius: 25px;
  box-shadow: rgb(0 0 0 / 16%) 0 1px 10px;
}
.confirmContainerInner {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  text-align: left;
  padding: 10px;
}
.inner-overflow-container {
  max-height: 90%;
  overflow-y: auto;
  margin-bottom: 10px;
  margin: 5px;
  border-top: 1px #d5d5d5 solid;
  border-bottom: 1px #d5d5d5 solid;
}
.confirmContainerInner1 {
  background-color: #f5f5f5;
  margin: 5px;
  padding: 10px;
  border-radius: 25px;
  flex-basis: 25%;
  box-shadow: rgb(0 0 0 / 16%) 0 1px 10px;
}
.animate-route-select {
  animation: animate-table-row 1s ease;
}
@keyframes animate-table-row {
  from {
    margin-left: -50px;
  }
  to {
    margin-left: 0;
  }
}
.route-table-container {
  background-color: #fff;
  margin: 5px;
  padding: 10px;
  border-radius: 25px;
  box-shadow: rgb(0 0 0 / 16%) 0 1px 10px;
}
.confirmContainerInner1 h2 {
  margin: 0;
  text-align: left;
  white-space: nowrap;
}
.scrollable-container {
  margin-top: 5px;
  height: 80px;
  overflow-y: auto;
  width: 100%;
  background-color: #e4e4e4;
  border-radius: 25px;
  box-shadow: rgba(0, 0, 0, 0.35) 0 5px 15px;
  resize: vertical;
}
.scrollable-container-inner {
  background-color: #e4e4e4;
  border-radius: 25px;
  padding-top: 5px;
  margin: 5px;
  text-align: left;
}
.scrollable-container-inner p {
  background-color: #cecece !important;
  width: fit-content;
  padding: 5px;
  border-radius: 99px;
  font-weight: 700;
  margin: 0;
}
.confirm-svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #e4e4e4;
  border-radius: 999px;
  padding: 5px;
  width: fit-content;
}
.confirm-svg svg {
  width: 35px;
  height: 35px;
  padding-right: 5px;
}
.confirm-svg h2 {
  margin: 0;
}
.confirm-container-address {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: wrap;
}
.package-details-header {
  background-color: #32ccfe;
  color: #fff;
  padding: 10px;
  border-radius: 50px;
  width: fit-content;
  margin: 0;
}
.close-shipment-info {
  width: 30px;
  height: 30px;
  margin-right: 5%;
  margin-top: 5px;
  transition-duration: 0.5s;
  cursor: pointer;
}
.close-shipment-info:hover {
  transition-duration: 0.5s;
  border-radius: 999px;
  background-color: #e4e4e4;
}
.print-button {
  background-color: #e4e4e4;
  color: #000;
  border: none;
  border-radius: 999px;
  padding: 5px 15px;
  width: fit-content;
  margin-left: 25px;
  margin-bottom: 5px;
  transition-duration: 0.5s;
  cursor: pointer;
}
.print-button:hover {
  transition-duration: 0.5s;
  background-color: #d5d5d5;
}
.create-button {
  background-color: #33f18a;
  color: #000;
  border: none;
  border-radius: 999px;
  padding: 5px 15px;
  width: fit-content;
  margin-left: 25px;
  margin-bottom: 5px;
  transition-duration: 0.5s;
  cursor: pointer;
}
.create-button:hover {
  transition-duration: 0.5s;
  background-color: #31d77b;
}
.close-shipment-info-container {
  display: flex;
  justify-content: flex-end;
}
.alert-container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  position: absolute;
  z-index: 97;
  left: 0;
  right: 0;
  top: 0;
  background: linear-gradient(
    rgba(0, 0, 0, 0.15) 0,
    rgba(0, 0, 0, 0.15) 90%,
    rgba(236, 236, 236, 0.05) 100%
  );
}
.inner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}
.text-container {
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.475);
  border-radius: 15px;
  width: 30%;
  z-index: 97;
  text-align: center;
  position: absolute;
  top: 15%;
  animation: animate-alert 0.5s ease;
  max-height: 70vh;
  overflow-y: auto;
}
.text-container h2 {
  margin-top: 0;
  background-color: #fe804d;
  color: #fff;
  border-radius: 15px 15px 0 0;
}
@keyframes animate-alert {
  from {
    top: 10%;
    opacity: 0;
  }
  to {
    top: 15%;
    opacity: 1;
  }
}
@media screen and (max-width: 1000px) {
  .text-container {
    width: 70%;
  }
}
@media only screen and (max-width: 820px) {
  .confirm-container-main {
    width: 90%;
  }
  .weight-container {
    background-color: #fff;
    margin: 5px 15px;
    width: fit-content;
  }
  .confirmContainerInner {
    flex-direction: column;
    flex-wrap: wrap;
  }
  .confirmContainerInner1 {
    width: fit-content;
  }
  .package-details-header {
    font-size: 1.6em;
  }
}
</style>